// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
const t = teacupWithHelpers('comment_options');

// eslint-disable-next-line @trello/no-module-logic
export const CommentOptionsTemplate = t.renderable(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (canEdit: any, isPublicUser: any) =>
    t.div('.comment-box-options', function () {
      if (canEdit && !isPublicUser) {
        t.a(
          '.comment-box-options-item.js-comment-add-attachment',
          { href: '#', title: t.l('add-an-attachment-ellipsis') },
          () => t.icon('attachment'),
        );
      }

      t.a(
        '.comment-box-options-item.js-comment-mention-member',
        { href: '#', title: t.l('mention-a-member-ellipsis') },
        () => t.icon('mention'),
      );

      t.a(
        '.comment-box-options-item.js-comment-add-emoji',
        { href: '#', title: t.l('add-emoji-ellipsis') },
        () => t.icon('emoji'),
      );

      return canEdit && !isPublicUser
        ? t.a(
            '.comment-box-options-item.js-comment-add-card',
            { href: '#', title: t.l('add-card-ellipsis') },
            () => t.icon('card'),
          )
        : null;
    }),
);
